(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["faqs-questions"] && !window.DesignMode) return;
  try {
    
  const toggleShowHideContentRow = document.querySelectorAll('.toggle-show-hide-content-row');

  toggleShowHideContentRow.forEach(function(toggleShowHideContent){
    toggleShowHideContent.addEventListener('click', function() {
      if ( toggleShowHideContent.classList.contains('active') ) {
        toggleShowHideContent.classList.remove('active');
      } else {
        toggleShowHideContent.classList.add('active');
      }
    }, false)
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection-for-archive"] && !window.DesignMode) return;
  try {
    
  var waypoint = new Waypoint({
    element: document.querySelector(".curated-boxes-section"),
    handler: function (direction) {
      const curatedBoxesTrigger = document.querySelector(".curated-boxes-trigger");

      if (direction === "down") {
        curatedBoxesTrigger.classList.add("relative");
      }

      if (direction === "up" && curatedBoxesTrigger.classList.contains("relative")) {
        curatedBoxesTrigger.classList.remove("relative");
      }
    },
    offset: "90%"
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grid-collection-products"] && !window.DesignMode) return;
  try {
    
  const sliderProduct = new Glide('.product-slider', {
    type: 'carousel',
    startAt: 0,
    gap: 10,
    perView: 1,
    peek: { before: 0, after: 95 },
  });

  sliderProduct.mount();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["impact-parallax"] && !window.DesignMode) return;
  try {
    

// Hide footer
document.getElementsByClassName("site-footer")[0].style.display = "none";

// Register GS plugins
gsap.registerPlugin(ScrollTrigger, SplitText);

// Parallax scene
gsap.utils.toArray(".parallax-scene").forEach((panel, i) => {
  ScrollTrigger.create({
    trigger: panel,
    start: "bottom bottom",
    // end: "-=1000",
    scrub: 1,
    pin: true,
    pinSpacing: false
  });
});

// Animate texts
gsap.utils.toArray(".animate-text").forEach((element, i) => {

  var tl = gsap.timeline(),
    mySplitText = new SplitText(element, {
      type: "words,chars"
    }),
    chars = mySplitText.chars; // an array of all the divs that wrap each character

  gsap.set(element, {
    perspective: 400
  });

  tl.from(chars, {
    duration: 0.8,
    opacity: 0,
    scale: 0,
    y: 60,
    rotationX: 140,
    // transformOrigin: "0% 50% -50",
    // ease: "back",
    stagger: 0.01
  });

  ScrollTrigger.create({
    trigger: element,
    start: "top 75%",
    toggleActions: "play none none none",
    animation: tl
  })

});

// Animate first path
gsap.set("#first-vector-parallax", {
  visibility: "visible"
});

var firstVectorTimeline = gsap.timeline();

firstVectorTimeline.to(".animation-1", {
  y: 5,
  opacity: 1,
  duration: 1,
  stagger: .4 // 0.1 seconds between when each ".box" element starts animating
});

ScrollTrigger.create({
  trigger: document.querySelectorAll("#semi-vh-scroll-section-3"),
  start: "top 50%",
  toggleActions: "play none none none",
  animation: firstVectorTimeline
})

// Animate second path
var secondVectorTimeline = gsap.timeline();

secondVectorTimeline.to(".animation-2", {
  y: 5,
  opacity: 1,
  duration: 1,
  stagger: .6 // 0.1 seconds between when each ".box" element starts animating
});

ScrollTrigger.create({
  trigger: document.querySelectorAll("#semi-vh-scroll-section-4"),
  start: "top 50%",
  toggleActions: "play none none none",
  animation: secondVectorTimeline
})

// Animate third path
var thirdVectorTimeline = gsap.timeline();

thirdVectorTimeline.to(".animation-3", {
  y: 5,
  opacity: 1,
  duration: 1,
  stagger: .4
});

ScrollTrigger.create({
  trigger: document.querySelectorAll("#semi-vh-scroll-section-6"),
  start: "top 50%",
  toggleActions: "play none none none",
  animation: thirdVectorTimeline
})


// Animate fourth path
var fourthVectorTimeline = gsap.timeline();

fourthVectorTimeline.to(".animation-4", {
  y: 5,
  opacity: 1,
  duration: 1,
  stagger: .4
});

ScrollTrigger.create({
  trigger: document.querySelectorAll("#semi-vh-scroll-section-7"),
  start: "top 50%",
  toggleActions: "play none none none",
  animation: fourthVectorTimeline
})

// Animate Numbers
gsap.utils.toArray(".stats-list-item-number").forEach((element, i) => {

  var tl = gsap.timeline();
  text = element.innerText; // an array of all the divs that wrap each character

  console.log(text);

  tl.to(element, {
    duration: 3,
    scrambleText: {
      text: text,
      chars: "0123456789"
    }
  });

  ScrollTrigger.create({
    trigger: element,
    start: "top 100%",
    toggleActions: "play none none none",
    animation: tl
  });

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid-globo-backup"]) return;
  try {
    
  // filter sort header 
  const filterSortHeader = document.querySelector('.filter-sort-header');
  filterSortHeader.onclick = function () {
    document.querySelector('.filter-sort-list-wrapper').classList.toggle('active');
    filterSortHeader.classList.toggle('active');
  };

  // filtering items 
  const filterListItem = document.querySelectorAll('.filter-list-item');

  filterListItem.forEach(function(filterItem){
    filterItem.addEventListener('click', function(){
      if( document.querySelector('.filter-list-item.active') ){
        document.querySelector('.filter-list-item.active').classList.remove('active');
      }
      filterItem.classList.add('active');
    }, false)
  });

  // view type 
  const viewTypeLarge = document.querySelector('.view-type-large');
  viewTypeLarge.onclick = function () {
    viewTypeLarge.classList.add('active');
    if( document.querySelector('.view-type-small.active') ){
      document.querySelector('.view-type-small.active').classList.remove('active');
    }
  };

  const viewTypeSmall = document.querySelector('.view-type-small');
  viewTypeSmall.onclick = function () {
    viewTypeSmall.classList.add('active');
    if( document.querySelector('.view-type-large.active') ){
      document.querySelector('.view-type-large.active').classList.remove('active');
    }
  };


  // filtering items (child)
  const filterListChildItem = document.querySelectorAll('.filter-list-child-item');

  filterListChildItem.forEach(function(filterChildItem){
    filterChildItem.addEventListener('click', function(){
      if( document.querySelector('.filter-list-child-item.active') ){
        document.querySelector('.filter-list-child-item.active').classList.remove('active');
      }
      filterChildItem.classList.add('active');
    }, false)
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // Pricing Table
  const productPricingTable = document.querySelectorAll('.product-details-pricing-table-list-item');

  productPricingTable.forEach(function (productPricingTableItem) {
    productPricingTableItem.addEventListener('click', function () {
      document.querySelector('.product-details-pricing-table-list-item.active').classList.remove('active');
      productPricingTableItem.classList.add('active');
    }, false)
  });

  // toggle show-hide content -->

  const toggleShowHideContentRow = document.querySelectorAll('.toggle-show-hide-content-row');

  toggleShowHideContentRow.forEach(function (toggleShowHideContent) {
    toggleShowHideContent.addEventListener('click', function () {
      if (toggleShowHideContent.classList.contains('active')) {
        toggleShowHideContent.classList.remove('active');
      } else {
        toggleShowHideContent.classList.add('active');
      }
    }, false)
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["side-by-side-with-animation"] && !window.DesignMode) return;
  try {
    
  var waypoint = (function(){
    new Waypoint({
      element: document.querySelector(".madebyhand-section"),
        handler: function () {
          if (document.querySelector("#lottie-animation.animation-not-started")) {
            document.getElementById("lottie-animation").load("https://assets5.lottiefiles.com/private_files/lf30_47es52gp.json");
            document
              .querySelector("#lottie-animation.animation-not-started")
              .classList
              .remove("animation-not-started");
          }
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["steps-with-image"] && !window.DesignMode) return;
  try {
    

var waypoint = new Waypoint({
  element: document.querySelector(".how-it-works-section"),
  handler: function () {
    document.querySelector(".how-it-works-step-list").classList.add("active");
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["types-of-customization"] && !window.DesignMode) return;
  try {
    

const sliderTypeofCustomize = new Glide('.glide', {
  type: 'carousel',
  startAt: 0,
  perView: 1
});

sliderTypeofCustomize.mount();


  } catch(e) { console.error(e); }
})();

})();
